export default __webpack_public_path__ + "static/media/logoGP.b6ee0a97.svg";